var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-container',{staticClass:"kst-autonumber-list"},[_c('kst-form',{attrs:{"title":_vm.title}},[_c('List',{attrs:{"failureList":_vm.failureList,"items":_vm.items,"isListLoading":_vm.isListLoading}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }